import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderVerticalComponent } from "./med-icon-border-vertical.component";

@NgModule({
  declarations: [
    MedIconBorderVerticalComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderVerticalComponent,
  ],
})
export class MedIconBorderVerticalModule { }
